import apiClient from './client';
import type { MonthlyRevenue } from '../types/monthlyRevenue';

/**
 * Client for the monthly revenue endpoint.
 *
 * Returns per-month Shopify revenue, Stripe app revenue (lifetime vs
 * subscription), and the combined total. The backend clamps `months` to
 * [1, 36] and caches each window ~30 minutes. Pass `refresh` to bypass cache.
 */
export async function getMonthlyRevenue(
  months: number = 12,
  refresh: boolean = false
): Promise<MonthlyRevenue> {
  const { data } = await apiClient.get<MonthlyRevenue>(
    '/admin/revenue/monthly/',
    { params: { months, ...(refresh ? { refresh: 1 } : {}) } }
  );
  return data;
}
